import { componentsThemeMap } from '../../componentsThemeMap.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import { ErrorBoundary } from '../../ui/ErrorBoundary.js';
import { TabNavigation } from '../../ui/TabNavigation.js';
import { Text } from '../../ui/Text.js';
import { jsx, jsxs } from 'react/jsx-runtime';
function WayfindingTabCards({
  eyebrow,
  headline,
  children,
  tabs,
  anchor,
  style = 'default',
  hasSpacingTop = true
}) {
  const colors = componentsThemeMap[style];
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "WayfindingTabCards",
      children: /*#__PURE__*/jsxs(SectionComponentLayout, {
        hasSpacingTop: hasSpacingTop,
        hasSpacingHorizontal: true,
        as: "section",
        anchor: anchor,
        flexDirection: "column",
        background: colors.background,
        hasNonDefaultBackgroundSpacingVertical: true,
        children: [eyebrow && /*#__PURE__*/jsx(Text, {
          variant: "label1",
          color: colors.foreground,
          children: eyebrow
        }), headline && /*#__PURE__*/jsx(Text, {
          spacingTop: eyebrow ? 4 : 0,
          variant: "display2",
          color: colors.foreground,
          children: headline
        }), /*#__PURE__*/jsx(TabNavigation, {
          startTabId: "0",
          tabs: tabs,
          style: style,
          children: children
        })]
      })
    })
  });
}
export { WayfindingTabCards };
//# sourceMappingURL=WayfindingTabCards.js.map
